'use client';

import { faPrint } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import clsx from 'clsx';

interface PrintButtonProps {
	onClick?: () => void;
	label?: string;
	className?: string;
}

export const PrintButton = ({ onClick, label = 'Print', className }: PrintButtonProps) => {
	const handleClick = () => {
		if (onClick) {
			onClick();
		} else {
			window.print();
		}
	};

	return (
		<Button
			type="button"
			variant="outline"
			className={clsx('shadow-none border-gray-500 px-[6px] py-2 font-semibold min-w-16 gap-1', className)}
			onClick={handleClick}
		>
			<FontAwesomeIcon icon={faPrint} />
			<p className="text-gray-600">{label}</p>
		</Button>
	);
};
